import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axios from "axios";


const LatestRegisteredOne = () => {
  const [investmentData, setInvestmentData] = useState([]);
  const navigate = useNavigate();
  const BaseUrl = process.env.REACT_APP_API;

  const getTokenFromLocalStorage = () => sessionStorage.getItem("authToken");

  const decodeToken = (token) => {
    try {
      const decoded = jwtDecode(token);
      return decoded.company_id || null;
    } catch (error) {
      console.error("Invalid token:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = getTokenFromLocalStorage();
      
        const company_id = decodeToken(token);
   
        const investmentResponse = await axios.get(`${BaseUrl}/getInvestmentsByID`, {
          params: { company_id },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (investmentResponse.status === 200) {
          setInvestmentData(investmentResponse.data || []);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [BaseUrl, navigate]);

  return (
    <div className="col-xxl-12 col-xl-12">
      <div className="card h-100">
        <div className="card-body p-24">
          <div className="d-flex flex-wrap align-items-center gap-1 justify-content-between mb-16">
            <ul className="nav border-gradient-tab nav-pills mb-0" id="pills-tab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center active"
                  id="pills-to-do-list-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-to-do-list"
                  type="button"
                  role="tab"
                  aria-controls="pills-to-do-list"
                  aria-selected="true"
                >
                  Investment History
                </button>
              </li>
            </ul>
          </div>

          <div className="table-responsive scroll-sm">
        {investmentData.length > 0 ? (
            <table className="table bordered-table sm-table mb-0">
            <thead>
                <tr>
                <th scope="col">Date</th>
                <th scope="col">NAV Quantity</th>
                <th scope="col">NAV Price</th>
                <th scope="col" className="text-center">Amount</th>
                </tr>
            </thead>
            <tbody>
                {investmentData.map((item, index) => (
                <tr key={index}>
                    <td>{new Date(item.nav_date).toLocaleDateString()}</td>
                    <td>{item.nav_quantity}</td>
                    <td>${item.nav_price}</td>
                    <td className="text-center">
                    <span className="bg-success-focus text-success-main px-24 py-4 rounded-pill fw-medium text-sm">
                        ${item.amount}
                    </span>
                    </td>
                </tr>
                ))}
            </tbody>
            </table>
        ) : (
            <div className="text-center p-4">
            <h6 >No Investment</h6>
            </div>
        )}
        </div>
        </div>
      </div>
    </div>
  );
};

export default LatestRegisteredOne;
